module.exports = __webpack_public_path__ + "img/about-us.b545caf9.png";